import { Box } from '@mui/material';
import { H1, Icon, P1R } from 'src/components';

function ContractorsEmpty({ title, description }: { title: string; description: string }) {
  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', flexDirection: 'column', mt: { xs: 0, sm: 14 } }}
    >
      <Icon name="contractors" />
      <H1 sx={{ my: 3 }}>{title}</H1>
      <P1R>{description}</P1R>
    </Box>
  );
}

export default ContractorsEmpty;
